import i18n from "@/i18n";
import axios from "axios";
import {
    createToastInterface,
    POSITION
} from 'vue-toastification'

const toast = createToastInterface({
    timeout: 5000
});

const STUDENT = '/student'
const STUDENT_WITH_QUERY = '/student/options'
const STUDENT_AND_PARENT_WITH_QUERY = '/students/options'
const PARENTS = "/parents" //"/student/{id}/parents"
const REGISTER = "/register";
const LOGIN = "/login";
const CHANGE_PASSWORD = "/change-password";
const REGISTRATION = "/registration";
const QUALIFY = "/qualify";

const STUDENT_RELATION = "/student-relation/";
const APPLICATIONFORM = "/application-form";
const STUDENT_UPDATE_REGISTRATION_STATUS = "/student/registration-status/update"

const PERSON_DETAIL = "/person-detail"; // ethnicity nationality religion
const PROVINCE = "/address/province/options"
const STUDENT_YEAR = "/student-year";
const PROGRAM = "/program";
const SALARY = "/salary";
const SEMESTER = "/academic-year/semester";

const FILE = "/file";

const REGISTRATIONFORMLINK = "registration/link"
const REGISTRATIONFORMSTUDENT = "registration/student/" // {id}

const ORGANIZATION_INFO = "organization-info"

const STUDENT_TRANSFER = "student/transfer"

const CONVERT_URL_TO_BASE64 = "convert/img-url/base64"

const httpCoreClient = axios.create({
    baseURL: process.env.VUE_APP_CORE_SERVICE_URL
});


const config = (request) => {
    const token = localStorage.getItem('Token')
    request.headers['Accept-Language'] = i18n.locale;

    if (token) {
        request.headers['Authorization'] = `Bearer ${token}`;
    }

    return request;
};

httpCoreClient.interceptors.request.use(config);

export const getClassroomFromCore = (academicYear, params = {}) => {
    // console.log(params)
    return httpClient.post(`classroom/${academicYear}/options`, params)
}

export const getProvinceFromCore = async () => {
    httpCoreClient.get(PROVINCE, {
        params: {
            code: process.env.VUE_APP_CORE_SERVICE_AZ_CODE,
        },
    })
};

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

const httpClientConfig = (request) => {
    const token = localStorage.getItem('Token')
    const registerToken = localStorage.getItem('registerToken')
    request.headers['Accept-Language'] = i18n.locale;

    if (token) {
        request.headers['Authorization'] = `Bearer ${token}`;
    } else if (registerToken) {
        request.headers['Authorization'] = registerToken;
        request.headers['appCode'] = "school_enroll";
    }

    return request;
};

const handleError = (error) => {
    const responseMessage = error?.response?.data?.status?.message ?? 'Internal server error, Please try again later.';
    toast.error(responseMessage, {
        timeout: 5000,
        position: POSITION.BOTTOM_RIGHT,
    });
    return Promise.reject(error);
}

const handleStatusCode = (response) => {
    if (response.data.status) {
        const errorCode = response.data.status.code || 0;
        const errorMessage = response.data.status.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        switch (errorCode) {
            case 0:
            case 200: // Ok
            case 204: // No Content
            case 2011:
                break;
            default:
                toast.error(errorMessage, {
                    timeout: 5000,
                    position: POSITION.BOTTOM_RIGHT,
                });
        }
    }
    return response;
};

httpClient.interceptors.request.use(httpClientConfig);

httpClient.interceptors.response.use(handleStatusCode, handleError);

export const getStudentRelation = (params) => {
    return httpClient.get(STUDENT_RELATION + params);
};

export const createAccount = (body) => {
    return httpClient.post(REGISTER, body);
};

export const getLoginValidate = (params = {}, email) => {
    return httpClient.get(`${LOGIN}/${email}`, {
        params
    });
};

export const updateStudentApplicationForm = (body, params) => {
    return httpClient.post(`${APPLICATIONFORM}/${params}`, body);
};

export const getPersonalDetail = () => {
    return httpClient.get(PERSON_DETAIL);
};


export const getStudentYear = () => {
    return httpClient.get(STUDENT_YEAR);
};

export const getChangePasswordLink = (params = {}) => {
    return httpClient.get(CHANGE_PASSWORD, {
        params
    });
};

export const getStudent = (params = {}) => {
    return httpClient.get(STUDENT, {
        params
    });
};

export const deleteStudent = (id) => {
    return httpClient.delete(STUDENT + `/${id}/delete`);
};

export const getStudentParents = (params = {}) => {
    return httpClient.get(`${STUDENT}/${params}${PARENTS}`);
};

export const getStudentWithQuery = (body = {}) => {
    return httpClient.post(STUDENT_WITH_QUERY, body);
};

export const getStudentsAndParentsWithQuery = (body = {}) => {
    return httpClient.post(STUDENT_AND_PARENT_WITH_QUERY, body);
};

export const updateStudentRegistrationStatus = (body = {}) => {
    return httpClient.post(STUDENT_UPDATE_REGISTRATION_STATUS, body);
};

export const updateStudentExamResult = (id, body = {}) => {
    return httpClient.post(`${STUDENT}/exam-result/${id}/update`, body)
}

export const updateStudentNotation = (id, body = {}) => {
    return httpClient.post(`student/notation/${id}/update`, body)
}

export const postChangePassword = (body, token) => {
    return httpClient.post(`${CHANGE_PASSWORD}/${token}`, body)
};

export const getValidateChangePassword = (token) => {
    return httpClient.get(`${CHANGE_PASSWORD}/validate/${token}`)
}

export const getRegistrationForm = (params) => {
    return httpClient.get(REGISTRATION + '/form', {
        params
    });
};

export const getRegistrationFormById = (id) => {
    return httpClient.get(REGISTRATION + `/form/${id}`);
};

export const createRegistrationForm = (body) => {
    return httpClient.post(REGISTRATION + '/form', body);
};

export const updateRegistrationForm = (id, body) => {
    return httpClient.patch(REGISTRATION + `/form/${id}`, body);
};

export const deleteRegistrationForm = (id) => {
    return httpClient.delete(REGISTRATION + `/form/${id}`);
};

export const validateRegistrationFormName = (body) => {
    return httpClient.post(REGISTRATION + `/form/validate`, body);
};

export const getRegistrationPlanByFormId = (id, params) => {
    return httpClient.get(REGISTRATION + `/${id}/plan`, {
        params
    });
};

export const getRegistrationPlan = (params) => {
    return httpClient.get(REGISTRATION + '/plan', {
        params
    });
};

export const getImageBase64FromUrl = (image_url) => {
    return httpClient.post(CONVERT_URL_TO_BASE64, {
        image_url: image_url
    })
}

export const getRegistrationCalendar = (params) => {
    return httpClient.get(REGISTRATION + `/calendar`, {
        params
    });
};
export const getRegistrationCalendarById = (id) => {
    return httpClient.get(REGISTRATION + `/calendar/${id}`);
};

export const getRegistrationCalendarPlanByFormId = (id, params) => {
    return httpClient.get(REGISTRATION + `/calendar/${id}/plan`, {
        params
    });
};

export const getRegistrationCalendarPlanById = (id, planId, params) => {
    return httpClient.get(REGISTRATION + `/${id}/plan/${planId}`, {
        params
    });
};

export const getRegistrationPlanStudentByPlanId = (id, params) => {
    return httpClient.get(REGISTRATION + `/plan/${id}/student`, {
        params
    });
};

export const deleteRegistrationStudent = (id) => {
    return httpClient.delete(REGISTRATION + `/${id}/student`);
};

export const getRegistrationFormByStudent = (id) => {
    return httpClient.get(REGISTRATIONFORMSTUDENT + id)
}

export const getRegisterFormQualify = () => {
    return httpClient.get(`${REGISTRATION}${QUALIFY}`)
}

export const getStudentQualify = (params = {}) => {
    return httpClient.get(`${STUDENT}${QUALIFY}`, {
        params
    })
}

export const getProgram = (params) => {
    return httpClient.get(PROGRAM, {
        params
    });
};
export const getSalary = () => {
    return httpClient.get(SALARY);
};

export const getSemesterYear = (params = {}) => {
    return httpClient.get(SEMESTER, {
        params
    })
}

export const getOrganization = () => {
    return httpClient.get(ORGANIZATION_INFO);
};

export const getRegisterFormIDFromLink = (params) => {
    return httpClient.get(REGISTRATIONFORMLINK, {
        params
    });
}

export const getProvince = () => {
    return httpClient.get(PROVINCE);
}

export const getDistrictByProvince = (province) => {
    return httpClient.get("/address/" + province + "/district/options");
}

export const getSubdistrictByProvince = (district) => {
    return httpClient.get("/address/" + district + "/sub-district/options");
}

export const getRegistrationDownloadById = (id) => {
    return httpClient.get(REGISTRATION + `/calendar/download/${id}`);
};

export const getRegistrationDownloadByIdAndPlanId = (id, plan_id, params) => {
    return httpClient.get(REGISTRATION + `/calendar/download/${id}/${plan_id}`, {
        params
    });
};

// payment
const PAYMENT_MOCK = "/api/v2-mock/qr/request"
const PAYMENT_REAL = process.env.VUE_APP_PAYMENT_API_PATH

const PAYMENT_CALLBACK = "/payment/callback"
const PAYMENT_UPDATE = "/payment/update"
const PAYMENT_BACK_OFFICE = "/payment/backoffice/add"
const PAYMENT_RECODE = "/payment/recode/"
const DOCUMENT_RECODE = "/document/recode/"

const paymentClient = axios.create({
    baseURL: process.env.VUE_APP_PAYMENT_GATEWAY_HOST_URL
})

paymentClient.interceptors.request.use(config);

export const generateMockPayment = (body = {}) => {
    return paymentClient.post(PAYMENT_MOCK, body);
}

export const generatePayment = (body = {}) => {
    return paymentClient.post(PAYMENT_REAL, body);
}

export const sentPaymentCallback = (body = {}) => {
    return httpClient.post(PAYMENT_CALLBACK, body)
}

export const sentPaymentEvidence = (body = {}) => {
    return httpClient.post(PAYMENT_UPDATE, body)
}

export const addPaymentBackOffice = (body = {}) => {
    return httpClient.post(PAYMENT_BACK_OFFICE, body)
}

export const getPaymentDocument = (id) => {
    return httpClient.get(PAYMENT_RECODE + id)
}

export const getRegistrationDocument = (id) => {
    return httpClient.get(DOCUMENT_RECODE + id)
}

export const getSwitchSystemList = () => {
    return httpClient.get('/get-switch-system-list')
}

export const getTokenRequest = (body) => {
    return httpClient.post('/token', body)
}

export const getUrlSwitchSystem = (body) => {
    return httpClient.post('/get-url-switch-system', body)
}

  // export file
// const EXPORT_EXCEL_CANDIDATEVIE = "register/candidate/{register_form_id}/{register_plan_id}/export/excel"

export const exportExcelApplicant = (student_id, filename, responseType = "blob") => {
    return httpClient.get(`student-relation/${student_id}/export/excel`, {
        params:{
            filename: filename
        },
        responseType: responseType
    })
}
export const exportExcelCandidate = (register_form_id, register_plan_id, filename, responseType = "blob") => {
    return httpClient.get(`register/candidate/${register_form_id}/${register_plan_id}/export/excel`, {
        params:{
            filename: filename
        },
        responseType: responseType
    })
}

export const exportExcelCalendar = (register_form_id, filename, responseType = "blob") => {
    return httpClient.get(`register/calendar/${register_form_id}/export/excel`, {
        params:{
            filename: filename
        },
        responseType: responseType
    })
}

export const studentTransfer = (body) => {
    return httpClient.post(STUDENT_TRANSFER, body)
}

export const uploadFile = (body, params = {}) => {
    return httpClient.post(`${FILE}/upload`,
        body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            params
        })
}

export const downloadFile = (body) => {
    return httpClient.post(`${FILE}/download`,
        body, {
            responseType: "arraybuffer",

        })
}

export const downloadAsZipFile = (body) => {
    return httpClient.post(`${FILE}/compress`,
        body, {
            responseType: "blob",
        })
}

export const uploadStudentPicture = (body, params = {}) => {
    return httpClient.post(`picture/upload`,
        body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            params
        })
}

export const deleteDocumentFile = (body, student_id) => {
    return httpClient.delete(`${FILE}/delete/${student_id}`, {
        data: {
            body
        }
    })
}

export const downloadAllFile = (body, student_id) =>  {
    return httpClient.post(`file/compress/${student_id}`,
        body, {
        headers: {
            // "Content-Disposition": "attachment; filename=" + `${name}.zip`,
            "Content-Type": "multipart/form-data",
        }
    })
}

export const exportExcelRegistrationResult = (id, plan_id, params, responseType = "blob") => {
    return httpClient.get(REGISTRATION + `/result/${id}/${plan_id}/export/excel`, {
        params,
        responseType: responseType
    })
}
